import { Box, Grid } from '@mui/material';
import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';
import { useState } from 'react';
import { Item, WsButton, WsTypoColors, WsTypography, WsTypoVariants } from 'wisestep-base';

const PlanCheckoutForm = ({
  updateUser,
  showPayButton = false,
}: {
  updateUser?: boolean;
  showPayButton?: boolean;
}) => {
  const [diableButton, setDisableButton] = useState(false);
  const stripe = useStripe();
  const elements = useElements();

  const handleSubmit = async (event) => {
    setDisableButton(true);
    event.preventDefault();
    if (!stripe || !elements) {
      setDisableButton(false);
      return;
    }
    const result = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: updateUser
          ? window.location.href + '?success=true&update=true'
          : window.location.href + '?success=true',
      },
    });
    if (result.error) {
      switch (result.error.type) {
        case 'api_error':
          window.location.href = window.location.href + '?success=fail';
          break;
        case 'card_error':
          window.location.href = window.location.href + '?success=fail';
          break;
        case 'idempotency_error':
          window.location.href = window.location.href + '?success=fail';
          break;
        case 'invalid_request_error':
          window.location.href = window.location.href + '?success=fail';
          break;
      }
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Grid item xs={12}>
        <Item>
          <Grid container mt={1.5}>
            <Grid item xs={12} textAlign="center">
              <WsTypography variant={WsTypoVariants.TITLE} bold>
                We are processing your payment with Stripe
              </WsTypography>
            </Grid>
            <Grid item xs={2}></Grid>
            <Grid item xs={8} mt={5}>
              <PaymentElement />
              <Box mt={4}>
                <WsButton
                  disabled={diableButton}
                  variant="contained"
                  size="large"
                  fullWidth
                  type="submit"
                >
                  {showPayButton ? 'Pay Now' : 'Subscribe'}
                </WsButton>
              </Box>
              <Box mt={3}>
                <WsTypography bold variant={WsTypoVariants.BODY2} color={WsTypoColors.QUINARY}>
                  By confirming your subscription, you allow Wisestep to charge your card for this
                  payment and future payments in accordance with their terms
                </WsTypography>
              </Box>
            </Grid>
            <Grid item xs={2}></Grid>
          </Grid>
        </Item>
      </Grid>
    </form>
  );
};

export default PlanCheckoutForm;
